'use client'
import {useEffect, useRef, useState} from 'react';

interface ShowCopyProps{
  id: string | number;
}

const useShowCopy = () => {
  const [isShow, setIsShow] = useState<Record<string, boolean>>({
    [""]: false
  });
  const timeoutRef = useRef<NodeJS.Timeout>(null);
  const showCopy = ({id}:ShowCopyProps,duration = 2000) => {
    setIsShow({
      [id]: true
    });
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      setIsShow({
        [id]:false
      });
    }, duration);
  };
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return { isShow, showCopy };
};

export default useShowCopy;